module.exports = __webpack_public_path__ + "static/media/logo-blue-connect.531a26de.svg";